<template>
  <div class="mb-6">
    <h3 class="text-lg font-semibold">Kelionės laikai:</h3>
    <ul class="timeline timeline-vertical">
      <li v-for="(waypoint, index) in waypoints" :key="index">
        <hr v-if="index !== 0" />
        <div class="timeline-middle">
          <div :class="['rounded-full w-4 h-4', getDotColor(waypoint)]"></div>
        </div>
        <div class="timeline-end">
          <div
            class="rounded-md p-2"
            :class="{
              'bg-base-200 shadow-xs hover:bg-base-300 hover:cursor-pointer':
                index !== 0 && index !== waypoints.length - 1,
            }"
            @click="selectTrip(waypoint.trip_id)"
          >
            <div class="font-semibold">{{ waypoint.address }}</div>
            <div v-if="waypoint.trip_id && waypoint.trip_id !== 9999">
              Pavėžėjimo nr.: {{ waypoint.trip_id }}
            </div>
            <div>Numatytas laikas: {{ waypoint.time }}</div>
            <div v-if="waypoint.time_fact">
              Faktinis laikas: {{ waypoint.time_fact }}
            </div>
            <div v-if="waypoint.timePlanning" class="text-base">
              Planuojamas laikas: {{ waypoint.timePlanning }}
            </div>
            <div
              v-if="
                waypoint.timeValid === false &&
                index !== 0 &&
                index !== waypoints.length - 1
              "
              class="badge badge-error mr-1"
            >
              Netinka laikas
            </div>
            <div
              v-if="waypoint.isInRestriction"
              class="badge badge-warning mr-1"
            >
              Patenka į buferį
            </div>
            <div
              v-if="['start', 'finish', 'planning'].includes(waypoint.type)"
              class="badge badge-outline mr-1"
            >
              {{ getLabel(waypoint.type) }}
            </div>
          </div>
        </div>
        <hr v-if="index !== waypoints.length - 1" />
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

// Define the emit function
const emit = defineEmits(["selectTrip"]);

defineProps({
  waypoints: {
    type: Array,
    required: true,
  },
});

const getDotColor = (waypoint) => {
  if (waypoint.type === "start" || waypoint.type === "finish")
    return "bg-neutral";
  if (waypoint.time_fact) return "bg-success";
  if (waypoint.timeValid === false) return "bg-error";
  return "bg-error";
};

const getLabel = (type) => {
  switch (type) {
    case "start":
      return "Pradžia";
    case "finish":
      return "Pabaiga";
    case "planning":
      return "Naujas pavėžėjimas";
    default:
      return "";
  }
};

// Function to handle trip selection
const selectTrip = (tripId) => {
  if (tripId != null) {
    emit("selectTrip", tripId);
  }
};
</script>
